<template>
  <div class="stepContainer step">
    <common-header :title="courseInfo.siteCourseName" />
    <div class="m-content">
      <div class="dln_dl">
        <div class="dln_title">证券业从业人员资格考试</div>
        <div class="dln_dlcon">
          <div class="dln_btn">
            <button class="start"
                    @click="examStart"></button>
          </div>
          <ul>
            <li>
              准考证号：<input type="text"
                     class="input3"
                     value="052201645152050119"
                     disabled="disabled"></li>
            <li>报名序号：<input type="password"
                     class="input3"
                     value="123456789"
                     disabled="disabled">
            </li>
          </ul>
        </div>
        <p class="dln_tips">此系统为证券业从业人员资格考试，此准考证号、报名序号仅供考生模拟使用，非真实准考证号、报名序号！</p>
      </div>
    </div>
    <div class="bottom"></div>
  </div>
</template>
<script>
import { CommonHeader } from '@components/common'
import { mapGetters } from 'vuex'
import { setPageTitle, isEmptyObject, parseNumber, getCookie } from '@/utils'
import { checkTempPaper } from '@api'

export default {
  name: 'Step1',
  components: {
    CommonHeader
  },
  computed: {
    ...mapGetters(['siteData']),
  },
  data() {
    return {
      courseInfo: {},
      siteCourseID: '',
      courseID: '',
      intro: '',
      isClick: false,
      flag: '',
    }
  },
  async mounted() {
    const { flag } = this.$route.params
    let _flag = flag === 'paidExam' ? '' : flag
    const { siteCourseID, courseID } = this.$route.query
    const { majorID } = this.$categoryInfo
    this.siteCourseID = parseNumber(siteCourseID)
    this.courseID = courseID

    if (isEmptyObject(this.siteData)) {
      let params = {
        flag: _flag,
        majorID: majorID,
        siteCourseID: this.siteCourseID,
      }
      await this.$store
        .dispatch('getCurrentSiteInfo', params)
        .then((res) => {
          this.courseInfo = res.currentCourse
        })
        .catch((err) => {
          this.$message.error(err.msg)
        })
    } else {
      this.courseInfo = this.siteData.currentCourse
    }
    document.title = setPageTitle(this.courseInfo.siteCourseName)
  },
  methods: {
    toPrev() {
      const { flag: _flag } = this.$route.query
      if (_flag === 'ordinary') {
        window.close();
      }
      const { flag } = this.$route.params
      this.$router.push({
        path: `/${flag}/mockExam`,
        query: {
          siteCourseID: this.siteCourseID,
          courseID: this.courseID,
        },
      })
    },
    examStart() {
      const { flag } = this.$route.query
      if (flag === 'ordinary') {
        return this.$router.push({
          path: '/ordinaryExam',
          query: { ...this.$route.query },
        })
      }
      let uid = getCookie('cdeluid') || ''
      let params = {
        siteCourseID: this.siteCourseID,
        flag: this.flag,
        userID: parseNumber(uid),
      }
      // 查询是否有临时保存试题
      checkTempPaper(params).then((res) => {
        const { flag } = this.$route.params
        if (res.length > 0) {
          const tempData = res[0]
          let _confirm = confirm(
            '请确认 ：是否继续上次未完成的试卷?\n按“确定”将打开上次的试卷\n按“取消”则打开新试卷'
          )
          if (_confirm) {
            return this.$router.push({
              path: `/${flag}/doExam`,
              query: {
                siteCourseID: this.siteCourseID,
                courseID: this.courseID,
                bizID: String(tempData.bizID),
                spendTime: String(tempData.spendTime),
                temp: '2',
              },
            })
          } else {
            return this.$router.push({
              path: `/${flag}/doExam`,
              query: {
                siteCourseID: this.siteCourseID,
                courseID: this.courseID,
                // bizID: String(tempData.bizID),
                spendTime: 0,
                temp: '1',
                includeTempButAbandon: '1',
              },
            })
          }
        }
        return this.$router.push({
          path: `/${flag}/doExam`,
          query: {
            siteCourseID: this.siteCourseID,
            courseID: this.courseID,
            temp: '1',
          },
        })
      })
    },
  },
}
</script>
